import { FileUploadResponse } from '~repositories/hooks/use-file-upload'

const addFiles = (maxNum: number, result: string[], response: FileUploadResponse[]) => {
  if (maxNum <= 1) {
    return response[0]?.remoteUri ? [response[0].remoteUri] : []
  }

  const newFiles = response.filter(res => res?.remoteUri).map(res => res.remoteUri)

  return [...newFiles, ...result].slice(0, maxNum)
}

export default addFiles
